import { render, staticRenderFns } from "./preview.vue?vue&type=template&id=40d0cb43&scoped=true&lang=pug&"
import script from "./preview.vue?vue&type=script&lang=js&"
export * from "./preview.vue?vue&type=script&lang=js&"
import style0 from "./preview.vue?vue&type=style&index=0&id=40d0cb43&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d0cb43",
  null
  
)

/* custom blocks */
import block0 from "~/lang/blog?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Fubuntu%2Fnuxt%2Fbonkers%2Freleases%2F20230921151340%2Fcomponents%2Fsite%2Fblog%2Fpreview.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {WidgetsImage: require('/home/ubuntu/nuxt/bonkers/releases/20230921151340/components/widgets/image.vue').default})
